import { OverlayTrigger } from "react-bootstrap";
import { TextCss } from "../GlobalCss/TextCss";
const CustomTooltip = ({
          children,
          content,
          disabled =false
      }: {
          children?: React.ReactElement;
          content: string | number;
          disabled?:boolean
      }) => {
        if (disabled) {
    return children ? children : <span>{content}</span>;
  }

          return (
              <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={
                      <div className="chart-tooltip">
                          <div className={TextCss.black.sub_text_400_12}>{content}</div>
                          <div className="chart-tooltip-arrow"></div>
                      </div>
                  }
              >
                  {children ? children : <span>{content}</span>}
              </OverlayTrigger>
          );
      };
export default CustomTooltip